import { PublicKeyCredentialCreationOptionsJSON, PublicKeyCredentialRequestOptionsJSON } from '@github/webauthn-json/dist/types/basic/json'
import { OAuthState } from './oAuth'

export enum BiometricLoginStatus {
  NotStarted,
  Started,
  Finished,
  Error,
}

export const BIOMETRIC_MAX_DENIED_COUNT = 5
export const BIOMETRIC_DENIED_DAYS = 7

export const BiometricErrorNameTypes = ['NotAllowedError', 'HierarchyRequestError']

export interface ConsumerCredential {
  id: string
  userAgent: string
  registrationDate: string
}

export interface StartBiometricRegistrationData {
  requestId: string
  publicKeyCredentialCreationOptions: PublicKeyCredentialCreationOptionsJSON
}

export interface FinishBiometricRegistrationRequest {
  requestId: string
  credential: any
}

export interface StartRegistrationResponseData {
  startBiometricRegistrationData: StartBiometricRegistrationData
  creationOptions: CredentialCreationOptions
}

export type GetConsumerCredentialsResponse = ConsumerCredential[]

export interface BiometricStartAuthenticationResponse {
  requestId: string
  publicKeyCredentialRequestOptions: PublicKeyCredentialRequestOptionsJSON
}

export interface BiometricFinishAuthenticationRequest {
  requestId: string
  credential: any
}

export interface BiometricSettings {
  credentials: Record<string, string[]>
}
export interface BiometricEligibility {
  oAuthState?: OAuthState
  isUserVerifyAuthenticatorAvailable: boolean
  isBiometricCapableBrowser: boolean
  isLoggedInWithOAuth: boolean
  isPrivateBrowsingMode?: boolean
  isCashOnlyCohort?: boolean
}

export interface ConsumerEmailAndMobile {
  email?: string | null
  mobile?: string | null
}

export type BiometricsCheckTrigger = (
  biometricsEligibilityCheckPayload: BiometricEligibility | boolean,
  isMobileLogin: boolean,
  email: string | undefined,
  mobile: string | undefined
) => Promise<boolean>
